module.exports = __webpack_public_path__ + "static/media/15 Тихое фортепиано - Держите ваше внимание высоким.c82e9958.mp3";